import { render, staticRenderFns } from "./results.vue?vue&type=template&id=71a1d654&scoped=true"
import script from "./results.vue?vue&type=script&lang=js"
export * from "./results.vue?vue&type=script&lang=js"
import style0 from "./results.vue?vue&type=style&index=0&id=71a1d654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1d654",
  null
  
)

export default component.exports